import React from "react";

// 🌟 1. IMPORTANT: User needs to update this path to where they save image_1.png
import finalCarpoolIllustration from "../assets/carpooling.png";

export default function HomeExtraSlides() {
  const services = [
    {
      title: "Share Your Car",
      desc: "Post empty seats, split fuel costs.",
      icon: "🚘",
    },
    {
      title: "Bike Pooling",
      desc: "Zip through traffic, share the ride.",
      icon: "🏍️",
    },
    {
      title: "SUV Journeys",
      desc: "Extra space for longer trips & luggage.",
      icon: "🚙",
    },
    {
      title: "Bus & Tempo",
      desc: "Group travel made simple and cheap.",
      icon: "🚐",
    },
    {
      title: "Eco-Friendly",
      desc: "Fewer vehicles, cleaner city air.",
      icon: "🌿",
    },
    {
      title: "Massive Savings",
      desc: "Cut your daily commute costs by 60%.",
      icon: "💸",
    },
  ];

  return (
    <section className="extra-slides-wrapper">
      {/* 🟢 INJECTED PREMIUM CSS 🟢 */}
      <style>{`
        .extra-slides-wrapper {
          font-family: 'Inter', system-ui, sans-serif;
          padding: 60px 20px;
          max-width: 1200px;
          margin: 0 auto;
        }

        /* --- 1. OUR SERVICES STYLING --- */
        .services-section {
          margin-bottom: 100px;
        }
        .services-main-title {
          font-size: clamp(32px, 4vw, 42px);
          font-weight: 800;
          color: #111827;
          margin-bottom: 40px;
          display: inline-block;
          position: relative;
        }
        /* Yellow Underline matching the reference */
        .services-main-title::after {
          content: '';
          position: absolute;
          left: 0;
          bottom: -10px;
          width: 55%;
          height: 4px;
          background-color: #fbbf24; 
          border-radius: 2px;
        }
        
        .services-grid-layout {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
          gap: 24px;
        }
        
        .service-layout-card {
          background-color: #f8f9fa;
          border-radius: 16px;
          padding: 28px 32px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          transition: transform 0.3s ease, box-shadow 0.3s ease, background-color 0.3s ease;
          cursor: pointer;
          border: 1px solid rgba(226, 232, 240, 0.4);
        }
        
        .service-layout-card:hover {
          transform: translateY(-6px);
          background-color: #ffffff;
          box-shadow: 0 16px 32px rgba(15, 23, 42, 0.08);
          border-color: rgba(0, 180, 216, 0.2);
        }
        
        .service-text-content {
          flex: 1;
          padding-right: 16px;
          text-align: left;
        }
        
        .service-item-title {
          font-size: 22px;
          font-weight: 700;
          color: #111827;
          margin-bottom: 8px;
          letter-spacing: -0.3px;
        }
        
        .service-item-desc {
          font-size: 15px;
          color: #64748b;
          line-height: 1.5;
          margin: 0;
        }
        
        .service-item-icon {
          font-size: 64px;
          flex-shrink: 0;
          /* Drop shadow gives a 3D effect to standard emojis */
          filter: drop-shadow(2px 12px 16px rgba(0,0,0,0.12));
          transition: transform 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
        }
        
        .service-layout-card:hover .service-item-icon {
          transform: scale(1.15) rotate(-5deg);
        }

        /* --- 2. HOW IT WORKS STYLING --- */
        .slide-header {
          text-align: center;
          margin-bottom: 48px;
        }
        .slide-title {
          font-size: clamp(32px, 4vw, 36px);
          font-weight: 800;
          color: #111827;
          margin-bottom: 12px;
          letter-spacing: -0.5px;
        }
        .slide-subtitle {
          font-size: 18px;
          color: #64748b;
          max-width: 600px;
          margin: 0 auto;
        }
        
        .steps-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
          gap: 32px;
          margin-bottom: 100px;
        }
        
        .step-card {
          background: #ffffff;
          border-radius: 24px;
          padding: 40px 32px;
          text-align: center;
          box-shadow: 0 4px 20px rgba(15, 23, 42, 0.03);
          border: 1px solid rgba(226, 232, 240, 0.8);
          transition: transform 0.3s ease, box-shadow 0.3s ease;
          position: relative;
          overflow: hidden;
        }
        
        .step-card:hover {
          transform: translateY(-8px);
          box-shadow: 0 20px 40px rgba(0, 180, 216, 0.08);
          border-color: rgba(0, 180, 216, 0.25);
        }
        
        .step-number {
          position: absolute;
          top: -20px;
          right: -10px;
          font-size: 140px;
          font-weight: 900;
          color: rgba(0, 180, 216, 0.04);
          z-index: 0;
          line-height: 1;
        }
        
        .step-icon {
          font-size: 56px;
          margin-bottom: 24px;
          position: relative;
          z-index: 1;
          filter: drop-shadow(0 8px 12px rgba(0,0,0,0.08));
        }
        
        .step-title {
          font-size: 22px;
          font-weight: 700;
          color: #1e293b;
          margin-bottom: 12px;
          position: relative;
          z-index: 1;
        }
        
        .step-text {
          font-size: 16px;
          color: #64748b;
          line-height: 1.6;
          position: relative;
          z-index: 1;
        }

        /* --- 3. TRUST BANNER STYLING --- */
        .trust-banner {
          background: linear-gradient(135deg, #0f172a 0%, #1e293b 100%);
          border-radius: 32px;
          padding: 60px 48px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          gap: 40px;
          flex-wrap: wrap;
          color: #ffffff;
          box-shadow: 0 24px 48px rgba(15, 23, 42, 0.15);
          position: relative;
          overflow: hidden;
          margin-bottom: 100px;
        }
        
        .trust-banner::before {
          content: '';
          position: absolute;
          top: 0; left: 0; right: 0; bottom: 0;
          background: radial-gradient(circle at 100% 0%, rgba(0, 180, 216, 0.15) 0%, transparent 60%);
          pointer-events: none;
        }
        
        .trust-content {
          flex: 1;
          min-width: 300px;
          position: relative;
          z-index: 2;
        }
        
        .trust-badge {
          display: inline-block;
          background: rgba(0, 180, 216, 0.2);
          color: #38bdf8;
          padding: 6px 16px;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          margin-bottom: 24px;
        }
        
        .trust-title {
          font-size: clamp(28px, 4vw, 36px);
          font-weight: 800;
          margin-bottom: 16px;
          line-height: 1.2;
          letter-spacing: -0.5px;
        }
        
        .trust-text {
          font-size: 18px;
          color: #cbd5e1;
          line-height: 1.7;
        }
        
        .trust-stats {
          display: flex;
          gap: 48px;
          flex-wrap: wrap;
          position: relative;
          z-index: 2;
        }
        
        .stat-item h4 {
          font-size: 42px;
          font-weight: 800;
          color: #38bdf8;
          margin-bottom: 4px;
          line-height: 1;
        }
        
        .stat-item p {
          font-size: 14px;
          color: #94a3b8;
          text-transform: uppercase;
          letter-spacing: 1px;
          font-weight: 700;
          margin: 0;
        }

        /* 🌟 4. FINAL CTA SECTION STYLING (NEW - Polished Request) 🌟 */
        .final-cta-section {
          padding: 60px 40px;
          background-color: #f8f9fa; /* separate bg for section */
          border-radius: 32px;
          border: 1px solid rgba(226, 232, 240, 0.4);
        }
        .cta-flex-container {
          display: flex;
          align-items: center;
          gap: 60px;
          flex-wrap: wrap; /* image is full width on mobile, stacked below text */
        }
        .cta-image-wrap {
          flex: 1;
          min-width: 320px;
        }
        .cta-image-wrap img {
          width: 100%;
          border-radius: 20px;
          box-shadow: 0 12px 30px rgba(0,0,0,0.08);
          display: block;
        }
        .cta-text-wrap {
          flex: 1;
          min-width: 320px;
          text-align: left;
        }
        .cta-special-badge {
          display: inline-block;
          background: rgba(16, 185, 129, 0.15); /* green badge */
          color: #10b981;
          padding: 6px 16px;
          border-radius: 20px;
          font-size: 13px;
          font-weight: 800;
          text-transform: uppercase;
          letter-spacing: 1.5px;
          margin-bottom: 24px;
        }
        .cta-main-title {
          font-size: clamp(32px, 4.5vw, 48px);
          font-weight: 800;
          color: #0f172a;
          line-height: 1.1;
          margin-bottom: 24px;
          letter-spacing: -1px;
        }
        .cta-body-text {
          font-size: 18px;
          color: #64748b;
          line-height: 1.8;
          margin-bottom: 40px;
        }
        .btn-start-sharing {
          display: inline-block;
          background-color: #0f172a; /* dark primary button */
          color: white;
          padding: 16px 40px;
          border-radius: 12px;
          font-size: 16px;
          font-weight: 700;
          text-decoration: none;
          transition: background-color 0.3s ease;
        }
        .btn-start-sharing:hover {
          background-color: #334155;
        }

        /* --- MOBILE RESPONSIVENESS (OVERALL) --- */
        @media (max-width: 900px) {
          .cta-flex-container {
            justify-content: center;
            text-align: center;
          }
          .cta-text-wrap {
            text-align: center;
          }
        }
        @media (max-width: 768px) {
          .services-grid-layout {
            grid-template-columns: 1fr;
          }
          .trust-banner {
            padding: 48px 32px;
            text-align: center;
            justify-content: center;
            margin-bottom: 80px;
          }
          .trust-stats {
            justify-content: center;
            gap: 32px;
          }
        }
      `}</style>

      {/* 🌟 1. OUR SERVICES SECTION (Ride-Sharing Focused) */}
      <div className="services-section">
        <h2 className="services-main-title">Share Your Journey</h2>
        <div className="services-grid-layout">
          {services.map((service, index) => (
            <div key={index} className="service-layout-card">
              <div className="service-text-content">
                <h3 className="service-item-title">{service.title}</h3>
                <p className="service-item-desc">{service.desc}</p>
              </div>
              <div className="service-item-icon">
                {service.icon}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* 🌟 2. HOW IT WORKS SECTION */}
      <div className="slide-header">
        <h2 className="slide-title">How Vyango Works</h2>
        <p className="slide-subtitle">Your next intercity journey is just three simple steps away.</p>
      </div>

      <div className="steps-grid">
        <div className="step-card">
          <div className="step-number">1</div>
          <div className="step-icon">🔍</div>
          <h3 className="step-title">Find a Ride</h3>
          <p className="step-text">Enter your departure city, destination, and travel date. Browse verified drivers heading your way.</p>
        </div>

        <div className="step-card">
          <div className="step-number">2</div>
          <div className="step-icon">💬</div>
          <h3 className="step-title">Connect & Book</h3>
          <p className="step-text">Check driver ratings, chat securely within the app, and reserve your seat instantly.</p>
        </div>

        <div className="step-card">
          <div className="step-number">3</div>
          <div className="step-icon">🛣️</div>
          <h3 className="step-title">Travel Together</h3>
          <p className="step-text">Meet up at the designated spot, split the costs, and enjoy a comfortable, shared journey.</p>
        </div>
      </div>

      {/* 🌟 3. TRUST & SAFETY BANNER */}
      <div className="trust-banner">
        <div className="trust-content">
          <div className="trust-badge">Safety First</div>
          <h3 className="trust-title">Built on Trust and Community</h3>
          <p className="trust-text">
            Every user on Vyango goes through profile verification. With real-time chat, honest peer reviews, and secure matchmaking, you always know exactly who you are traveling with.
          </p>
        </div>
        
        <div className="trust-stats">
          <div className="stat-item">
            <h4>100%</h4>
            <p>Verified Profiles</p>
          </div>
          <div className="stat-item">
            <h4>24/7</h4>
            <p>Support Access</p>
          </div>
        </div>
      </div>

      {/* 🌟 4. FINAL CTA SECTION (NEW - Polished Request) 🌟 */}
      <div className="final-cta-section">
        <div className="cta-flex-container">
          <div className="cta-image-wrap">
            <img src={finalCarpoolIllustration} alt="Carpooling with Vyango Illustration" />
          </div>
          <div className="cta-text-wrap">
            <div className="cta-special-badge">VYANGO PARTNER EXPERIENCE</div>
            <h2 className="cta-main-title">Share More. Earn More. Find Your Best Journey.</h2>
            <p className="cta-body-text">
              Turn empty seats into extra income with Vyango. Our highly intuitive, attractive, and responsive platform makes sharing your car, bike, or SUV ride seamless and safe. Join thousands who are revolutionizing intercity travel and earning extra money along the way.
            </p>
            <a href="/post" className="btn-start-sharing">Start Sharing Today →</a>
          </div>
        </div>
      </div>

    </section>
  );
}